module.exports = __webpack_public_path__ + "assets/img/ontology.e8f89fd0.png";